export default __webpack_public_path__ + "static/media/2869279.995ab2d9.jpg";